module.exports = __webpack_public_path__ + "img/stepComplete.b6ca019d.png";